import { cn } from '@/lib/cn';
import { TypographyCaption, typographyVariant } from '@heidi/design-system/typography';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  loading: {
    defaultMessage: 'Loading…',
    id: 'components.dev.integration.jsonResult.loading',
  },
});

interface IntegrationDebugJsonResultProps {
  title: string;
  data?: unknown;
  error?: string;
  isLoading: boolean;
}

export function IntegrationDebugJsonResult({
  title,
  data,
  error,
  isLoading,
}: Readonly<IntegrationDebugJsonResultProps>) {
  const intl = useIntl();

  if (!isLoading && data === undefined && !error) return null;

  return (
    <div className="space-y-1.5">
      <TypographyCaption className="text-text-secondary">{title}</TypographyCaption>
      {isLoading ? (
        <TypographyCaption className="text-text-tertiary">
          {intl.formatMessage(messages.loading)}
        </TypographyCaption>
      ) : null}
      {error ? (
        <TypographyCaption role="alert" className="text-validation-destructive">
          {error}
        </TypographyCaption>
      ) : null}
      {data !== undefined ? (
        <pre
          className={cn(
            typographyVariant({ variant: 'caption' }),
            'max-h-72 overflow-auto rounded-md border border-border bg-background-secondary p-2 font-mono text-text-secondary'
          )}
        >
          {JSON.stringify(data, null, 2)}
        </pre>
      ) : null}
    </div>
  );
}
